import {
  Row,
  Col,
  Input,
  Modal,
  Tabs,
  Pagination,
  Select,
  Menu,
  Button,
  Dropdown,
  Icon,
  Form,
  message,
  Spin
} from "antd";
const TabPane = Tabs.TabPane;
const Option = Select.Option;
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
import WeaFormItem from "../../wea-form-item";
import cloneDeep from "lodash/cloneDeep";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import uniq from "lodash/uniq";
import isEqual from "lodash/isEqual";

import WeaInputSearch from "../../wea-input-search";
import WeaSearchBrowserBox from "../wea-search-browser-box";
import WeaAssociativeSearchMult from "../wea-associative-search-mult";
import Operation from "../../wea-transfer/operation";
import WeaBrowserMutiRight from "../wea-browser-muti-right";
import WeaTools from "../../wea-tools";
import WeaBrowserMutiLeft from "../wea-browser-muti-left";
import WeaBrowserTree from "../wea-browser-single-tree/WeaBrowserTree";
import WeaBrowserSearch from "../../wea-browser-search";
import WeaSelect from "../../wea-select";
import WeaNewScroll from "../../wea-new-scroll";
import uniqBy from "lodash/uniqBy";
import debounce from "lodash/debounce";
import isArray from "lodash/isArray";
import toArray from "lodash/toArray";
import isString from "lodash/isString";
import WeaLocaleProvider from "../../wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

const orgInfoArr = ["4", "57", "167", "168", "164", "194", "169", "170"];
const initialState = {
  showSearchAd: false,
  count: 0,
  visible: false,
  currentPage: 1,
  inputValue: "",
  searchPara: {},
  checkStrictly: true,
  browserConditions: [],
  leftListSelectedKeys: [],
  leftListSelectedData: [],
  leftTreeCheckedKeys: [],
  leftTreeCheckedData: [],
  loadAllTreeData: false,
  selectedValue: null,
  displayType: "",
  loading: true
};

class Main extends React.PureComponent {
  static Operation = Operation;
  static defaultProps = {
    mult: true,
    needCallDest: true,
    checkStrictly: true
  };
  constructor(props) {
    super(props);
    const { dataUrl } = this.props;
    this.state = {
      visible: null,
      initialShowSearchAd: false,
      showSearchAd: false,
      rightCheckedKeys: [], //右侧选择的keys
      rightDatas: [], // 右侧展示的数据
      leftListSelectedKeys: [], // 左侧table选择的keys
      leftListSelectedData: [], // 左侧table选择的数据
      leftTreeCheckedKeys: [], // 左侧tree选择的keys
      leftTreeCheckedData: [], // 左侧tree选择的数据
      selectedData: {}, // 搜索按钮选中的数据
      searchKeys: [], // 搜索按钮选择的keys
      listDatas: [],
      currentPage: 1,
      pageSize: props.pageSize || 10,
      count: 0,
      url: dataUrl,
      inputValue: "",
      searchPara: {},
      dataKey: "",
      noPgTableData: [],
      inputId: "",
      inputName: "",
      inputTop: [],
      inputBottom: [],
      browserConditions: [],
      displayType: "list", // list/tree
      contentType: 1, // 数据展示的类别
      quickSearch: "",
      defaultExpandedKeys: [],
      hiddenIds: "",
      checkStrictly: this.props.checkStrictly,
      loadAllTreeData: false,
      selectedValue: null,
      loading: true,
      dropmenuDatas: [],
      dataIcon: "",
      dataIconBgColor: "",
      dataIconFontColor: "",
      urlOfIframeInDialogParrentHeight: "100%",
      urlOfIframeInDialog: ""
    };
  }
  componentDidMount() {
    // 默认显示数据
    if (!isEmpty(this.props.replaceDatas)) {
      this.replaceSearchValues(this.props.replaceDatas);
    }
    if (!isEmpty(this.props.valueObj)) {
      this.replaceSearchValues(this.props.valueObj);
    }
    this.onBrowerClickInner = this.onBrowerClickInner.bind(this);
    this.props.initFunc && this.props.initFunc(this);
  }
  componentWillReceiveProps(nextProps) {
    if ("value" in nextProps && isEmpty(nextProps.value)) {
      this.setState({ searchKeys: [], selectedData: {} });
      this.refs.associativeSearch && this.refs.associativeSearch.clear();
    }
    if (
      "replaceDatas" in nextProps &&
      !isEqual(this.props.replaceDatas, nextProps.replaceDatas) &&
      !nextProps.replaceNotCtrl
    ) {
      this.replaceSearchValues(nextProps.replaceDatas || []);
      if (isEmpty(nextProps.replaceDatas)) {
        this.refs.associativeSearch && this.refs.associativeSearch.clear();
      }
    }
    if (
      "checkStrictly" in nextProps &&
      this.props.checkStrictly !== nextProps.checkStrictly
    ) {
      this.setState({ checkStrictly: nextProps.checkStrictly });
    }
  }
  setLoading(bool) {
    this.setState({ loading: bool });
  }
  formatInput(columns) {
    let inputId,
      inputName,
      inputTop = [],
      inputBottom = [];
    if (!isEmpty(columns)) {
      columns.forEach(item => {
        if (item.isInputCol === "true") {
          inputName = item.dbField || item.dataIndex;
        }
        if (item.isPrimarykey === "true") {
          inputId = item.dbField || item.dataIndex;
        }
        if (item.hide === "false") {
          if (item.showType === "1") {
            inputTop.push(item.dbField || item.dataIndex);
          }
          if (item.showType === "0") {
            inputBottom.push(item.dbField || item.dataIndex);
          }
        }
      });
    }
    if (!inputId) {
      inputId = "id";
    }
    if (!inputName) {
      inputName = "name";
    }
    this.setState({
      inputName: inputName,
      inputId: inputId,
      inputTop: inputTop,
      inputBottom: inputBottom
    });
  }
  datakeyTodatas(newDataKey, newCurrent, min, max, cb) {
    WeaTools.callApi("/api/ec/dev/table/datas", "POST", {
      dataKey: newDataKey,
      pageSize: this.state.pageSize,
      min: min,
      max: max
    })
      .then(
        data => {
          this.formatInput(data.columns);
          if (cb) cb(data);
          if (isArray(data.datas)) {
            this.setState({
              listDatas: data.datas
            });
          }
          if (data.count) {
            this.setState({
              count: data.count
            });
          }
          this.setLoading(false);
        },
        e => {
          console.log("api /api/ec/dev/table/datas error", e);
        }
      )
      .catch(e => this.props.onError && this.props.onError(e)),
      WeaTools.callApi("/api/ec/dev/table/counts", "POST", {
        dataKey: newDataKey
      })
        .then(
          data => {
            this.setState({
              count: data.count
            });
          },
          e => {
            console.log("api /api/ec/dev/table/counts error", e);
          }
        )
        .catch(e => this.props.onError && this.props.onError(e));
  }
  formatUrl(url, params) {
    if (url && !isEmpty(params)) {
      url = `${url}${WeaTools.getFd(params)}`;
    }
    return url;
  }
  getData(url, currentPage, hasPagination = false, searchPara, cb, companyId) {
    this.setLoading(true);
    const { pageSize, count } = this.state;
    url = url || this.state.url;
    let params = searchPara || this.state.searchPara || {};
    params = { ...params };
    currentPage = currentPage || this.state.currentPage;
    if (hasPagination) {
      params["min"] = (currentPage - 1) * pageSize + 1;
      params["max"] = currentPage * pageSize;
    }
    params["pageSize"] = pageSize;
    if (params["max"] && currentPage > 1) {
      if (params["max"] > count) params["max"] = count;
    }
    if (this.props.type == "194" || this.props.type == "57") {
      companyId = companyId || this.state.companyId;
      params["virtualCompanyid"] = companyId || "1";
      this.setState({ companyId: companyId });
    }
    WeaTools.callApi(this.formatUrl(url, params), "GET")
      .then(data => {
        if (data.iconSetting) {
          let dataIcon = "";
          let dataIconBgColor = "";
          let dataIconFontColor = "";
          if (data.iconSetting.icon) {
            dataIcon = data.iconSetting.icon;
          }
          if (data.iconSetting.bgColor) {
            dataIconBgColor = data.iconSetting.bgColor;
          }
          if (data.iconSetting.fontColor) {
            dataIconFontColor = data.iconSetting.fontColor;
          }
          this.setState({ dataIcon, dataIconBgColor, dataIconFontColor });
        }
        if (data.type == 1) {
          //分页table
          const dataKey = data.datas;
          this.setState(
            {
              displayType: "list",
              contentType: data.type
              // pageSize: data.pageSize || 10
            },
            () => {
              this.datakeyTodatas(
                dataKey,
                currentPage,
                params["min"],
                params["max"],
                cb
              );
            }
          );
        }
        if (data.type == 2) {
          //不分页的table
          this.setState({
            displayType: "list",
            contentType: data.type,
            listDatas: data.datas
          });
          this.formatInput(data.columns);
          if (cb) cb(data);
          this.setLoading(false);
        }
        if (data.type == 3) {
          //树
          !isEmpty(data.columns) && this.formatInput(data.columns);
          if (cb) cb(data);
          let keysArr = [];
          const { topPrefix } = this.props;
          keysArr.push(`${topPrefix}0-${data.datas.id}`);
          this.setState({
            displayType: "tree",
            contentType: data.type,
            treeData: data.datas,
            defaultExpandedKeys: keysArr,
            loadAllTreeData: data.isLoadAll
          });
          if (
            (this.props.type == "194" || this.props.type == "57") &&
            !companyId
          ) {
            const companysDefault = this.getCompany(data.companys) || {};
            this.setState({
              dropmenuDatas: data.companys,
              companyName: companysDefault.name,
              companyId: companysDefault.companyid
            });
          }
          if (this.props.type == "257") {
            this.setState({
              checkStrictly: data.checkStrictly
            });
          }
          this.setLoading(false);
        }
        if (data.type == 4) {
          //自定义分页的list
          this.formatInput(data.columns);
          this.setState({
            displayType: "list",
            contentType: data.type,
            listDatas: data.datas,
            count: data.total
          });
          if (cb) cb(data);
          this.setLoading(false);
        }
        if (data.type == 5) {
          this.setState({
            urlOfIframeInDialog: data.datas.pcurl
          });
        }
      })
      .then(result => {})
      .catch(e => this.props.onError && this.props.onError(e));
  }
  getCompany(datas, key) {
    for (let i = 0, leng = datas.length; i < leng; i++) {
      if (key) {
        if (key == datas[i].companyid) {
          return datas[i];
        }
      } else {
        if (Number(datas[i].companyid) >= 0) {
          return datas[i];
        }
      }
    }
  }
  getDefaultActiveKey() {
    let activeKey = "1";
    const { tabs } = this.props;
    if (Array.isArray(tabs) && !isEmpty(tabs)) {
      let t = tabs[0];
      tabs.forEach(tab => {
        if (tab.selected) {
          t = tab;
        }
      });
      return t.key;
    }
    return activeKey;
  }
  closeModal() {
    this.setState({ visible: false });
  }
  openModal() {
    this.onCustomClick();
  }
  onTabsChange(activeKey) {
    const { resetFields, setFieldsValue } = this.props.form;
    this.setState({ browserConditions: [] });
    resetFields();
    let url = this.getUrl(false, activeKey);
    let conditionURL = this.getConditionDataParamsUrl(activeKey);
    if (conditionURL) {
      this.getConditions(conditionURL, url);
      this.setState({
        activeKey,
        currentPage: 1
      });
    } else {
      const quickSearch = this.state.quickSearch || "name";
      this.getData(url, 1, true, this.defaultConditionParams);
      this.setState({
        url,
        activeKey,
        count: 0,
        currentPage: 1,
        inputValue: this.defaultConditionParams[quickSearch] || "",
        selectedValue: this.defaultConditionParams["date2during"] || "",
        showSearchAd: false,
        browserConditions: this.browserConditionsBk,
        searchPara: this.defaultConditionParams
      });
      setFieldsValue(this.defaultConditionParams);
    }
    this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  }
  onPageChange(page) {
    this.getData("", page, true);
    this.setState({ currentPage: page });
    this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  }
  getUrl(searched = false, activeKey) {
    activeKey = activeKey || this.state.activeKey;
    const { tabs, dataUrl } = this.props;
    let url = dataUrl;
    let tab = {};
    if (!isEmpty(tabs)) {
      tab = tabs.filter(m => m.key == activeKey)[0];
    }
    if (searched && !isEmpty(tabs)) {
      tabs.forEach(t => {
        if (t.isSearch) {
          tab = t;
          this.setState({ activeKey: t.key });
        }
      });
    }
    if (tab && tab.url) {
      url = `${tab.url}?`;
    }
    if (tab && !isEmpty(tab.dataParams)) {
      url = `${url}${WeaTools.getFd(tab.dataParams)}&`;
    }
    return url;
  }
  onSearchChange(v) {
    const quickSearch = this.state.quickSearch || "name";
    const { form } = this.props;
    const { setFieldsValue } = form;
    let params = {};
    let fieldNames = [];
    const formParams = {};
    let formFields = form.getFields() || [];
    for (const key in formFields) {
      if (formFields.hasOwnProperty(key)) {
        fieldNames.push(key);
      }
    }
    const newObject = cloneDeep(form.getFieldsValue(fieldNames));
    Object.keys(newObject).forEach(key => {
      const value = newObject[key];
      if (value || value === 0 || value === false) formParams[key] = value;
    });
    params = { ...formParams };
    params[quickSearch] = v;
    if (this.state.selectedValue)
      params["date2during"] = this.state.selectedValue;
    let url = this.getUrl(true);
    this.getData(url, 1, true, params); // 搜索获取数据
    setFieldsValue(params); // 高级搜索数据联动
    this.setState({
      url,
      inputValue: v,
      showSearchAd: false,
      searchPara: params
    });
    this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  }
  goSearch = e => {
    const { tabs, form } = this.props;
    const quickSearch = this.state.quickSearch || "name";
    e.preventDefault();
    let params = {};
    let fieldNames = [];
    const formParams = {};
    let formFields = form.getFields() || [];
    for (const key in formFields) {
      if (formFields.hasOwnProperty(key)) {
        fieldNames.push(key);
      }
    }
    const newObject = cloneDeep(form.getFieldsValue(fieldNames));
    Object.keys(newObject).forEach(key => {
      const value = newObject[key];
      if (value || value === 0 || value === false) formParams[key] = value;
    });
    params = { ...formParams };
    let url = this.getUrl(true);
    this.getData(url, 1, true, params, data => {
      if (
        window.browserSearchHandler &&
        typeof window.browserSearchHandler === "function"
      ) {
        window.browserSearchHandler(data, params, url);
      }
    }); // 搜索获取数据
    this.setState({
      url,
      searchPara: params,
      showSearchAd: false,
      inputValue: params[quickSearch] || ""
    });
    if (params["date2during"]) {
      this.setState({ selectedValue: params["date2during"] });
    }
    this.refs.weaSrcoll && this.refs.weaSrcoll.scrollerToTop();
  };
  getFields() {
    const { validateFields } = this.props.form;
    let params = {};
    validateFields((errors, object) => {
      if (!!errors) {
        return;
      }
      let newObject = cloneDeep({ ...object, ...conditionParamsBK });
      forEach(newObject, (value, key) => {
        if (value || value === 0 || value === false) params[key] = value;
      });
    });
    return params;
  }
  showModal() {
    this.setState({ visible: true });
    this.props.onOpen && this.props.onOpen();
  }

  setShowSearchAd(bool) {
    const { showSearchAd } = this.state;
    this.setState({ showSearchAd: bool, initialShowSearchAd: true });
  }
  onCustomClick = e => {
    e && e.preventDefault();
    if (this.props.onBeforeFocusCheck) {
      let cb = this.onCustomClickInner.bind(this);
      this.props.onBeforeFocusCheck(cb);
    } else {
      this.onCustomClickInner(e);
    }
  };
  onCustomClickInner = e => {
    const { memorise } = this.props;
    if (memorise) {
      const { searchKeys, selectedData } = this.state;
      this.onBrowerClick(searchKeys, selectedData);
    } else {
      this.onBrowerClick();
    }
  };
  getConditionDataParamsUrl(activeKey) {
    let url = "";
    const { tabs, conditionURL } = this.props;
    let tab = {};
    if (!isEmpty(tabs)) {
      tab = tabs.filter(m => m.key == activeKey)[0];
    }
    if (tab && !isEmpty(tab.conditionDataParams)) {
      url = `${conditionURL}${WeaTools.getFd(tab.conditionDataParams)}&`;
    }
    return url;
  }
  getConditions(conditionURL, url, cb) {
    const { setFieldsValue } = this.props.form;
    WeaTools.callApi(conditionURL, "GET").then(data => {
      let quickSearch;
      if (!isEmpty(data.conditions)) {
        data.conditions.forEach(item => {
          if (item.isQuickSearch) {
            quickSearch = item.domkey[0];
          }
        });
      }
      const params = WeaTools.getParamsByConditions(data.conditions);
      conditionParamsBK = params;
      setFieldsValue(params);
      this.browserConditionsBk = data.conditions;
      this.defaultConditionParams = { ...params };
      this.setState({
        browserConditions: data.conditions,
        quickSearch,
        url,
        searchPara: params,
        inputValue: params[quickSearch] || "",
        selectedValue: params["date2during"] || "",
        showSearchAd: false
      });
      if (cb) {
        this.getData(url, 1, true, params, cb);
      } else {
        this.getData(url, 1, true, params);
      }
    });
  }
  onBrowerClick = (keys, selectedObj) => {
    if (this.props.onBrowerClick) {
      this.props.onBrowerClick(keys, selectedObj, () => {
        this.onBrowerClickInner(keys, selectedObj);
      });
    } else {
      this.onBrowerClickInner(keys, selectedObj);
    }
  };
  onBrowerClickInner = (keys, selectedObj) => {
    const { resetFields } = this.props.form;
    this.setState(
      { inputValue: "", activeKey: this.getDefaultActiveKey() },
      () => {
        resetFields(); // 重置高级搜索
        let url = this.getUrl();
        const { conditionURL } = this.props;
        let conditionURLData =
          this.getConditionDataParamsUrl(this.state.activeKey) || conditionURL;
        this.getConditions(conditionURLData, url, () => {
          // reset selected data
          this.onBrowerChange(keys, selectedObj, false);
        });
        if (isEmpty(keys)) {
          this.setState({ searchKeys: [], selectedData: {}, rightDatas: [] });
        }
      }
    );
    this.showModal();
  };
  reload() {
    this.onBrowerClick();
  }
  get() {
    const { rightDatas, inputId } = this.state;
    let values = [];
    !isEmpty(rightDatas) &&
      rightDatas.forEach(d => {
        values.push(d[inputId] || d.id);
      });
    return {
      id: values,
      datas: rightDatas
    };
  }
  handleOk() {
    const { rightDatas, inputId, inputName, contentType } = this.state;
    const { maxLength } = this.props;
    let values = [];
    let selectedData = {};
    if (!isEmpty(rightDatas)) {
      if (maxLength && maxLength < this.count(rightDatas, true)) {
        window.alert(`所选的数量不能超过${maxLength}!`);
        return;
      }
      rightDatas.forEach(item => {
        item.id = item[inputId] || item.id;
        item.name =
          item[inputName + "span"] || item[inputName] || item.name || "";
        if (orgInfoArr.indexOf(this.props.type + "") > -1) {
          item.name =
            item.orgWholePathspan ||
            item[inputName + "span"] ||
            item[inputName] ||
            item.name;
        }
        selectedData[item.id] = item;
        values.push(item.id);
      });
    }
    values = uniq(values);
    if (this.props.onBeforeBrowserOK) {
      let cb = this.handleOkInner.bind(this);
      this.props.onBeforeBrowserOK(values, selectedData, cb);
    } else {
      this.handleOkInner(values, selectedData);
    }
  }

  handleOkInner(values, selectedData) {
    this.setState(
      {
        selectedData: selectedData,
        visible: false,
        searchKeys: values
      },
      () => {
        this.throwCurrentState(values.join(","), selectedData);
        this.props.onClose && this.props.onClose();
        this.setState(initialState); //初始化浏览框
        this.refs.browserRight && this.refs.browserRight.reset();
      }
    );
  }

  handleCancel() {
    this.setState(initialState); //初始化浏览框
    this.refs.browserRight && this.refs.browserRight.reset();
    this.props.onCancel && this.props.onCancel();
    this.props.onClose && this.props.onClose();
  }
  handleClear() {
    this.setState({
      visible: false,
      rightDatas: [],
      rightCheckedKeys: [],
      leftTreeCheckedKeys: [],
      leftListSelectedKeys: [],
      leftListSelectedData: [],
      leftTreeCheckedData: [],
      selectedData: {},
      searchKeys: []
    });
    this.setState(initialState); //初始化浏览框
    this.throwCurrentState("", []);
    this.refs.browserRight && this.refs.browserRight.reset();
    this.props.onClose && this.props.onClose();
    this.refs.associativeSearch && this.refs.associativeSearch.clear();
  }
  set(datas) {
    this.replaceSearchValues(datas);
  }
  replaceSearchValues(datas = []) {
    const { inputName } = this.state;
    let searchKeys = [],
      selectedData = {};
    datas.forEach(item => {
      if (item) {
        searchKeys.push(item.id);
        if (orgInfoArr.indexOf(this.props.type + "") > -1) {
          item.name =
            item.orgWholePathspan ||
            item[inputName + "span"] ||
            item[inputName] ||
            item.name;
        }
        selectedData[item.id] = item;
      }
    });
    this.setState({ searchKeys: searchKeys, selectedData: selectedData });
    let ids = uniq(searchKeys).join(",");
    this.setState({ hiddenIds: ids });
    // this.throwCurrentState(searchKeys.join(','), datas);
  }
  formatThrowDatas(datas) {
    const { inputId, inputName } = this.state;
    if (!isEmpty(datas)) {
      datas.forEach(d => {
        d.id = d[inputId] || d.id || "";
        d.name = d[inputName + "span"] || d[inputName] || d.name || "";
      });
    }
    return datas;
  }
  onBrowerChangeHandler(values, datas) {
    // if (this.props.onBeforeBrowserOK) {
    //   let cb = this.onBrowerChangeHandlerInner.bind(this);
    //   this.props.onBeforeBrowserOK(values, datas, cb);
    // } else {
    this.onBrowerChangeHandlerInner(values, datas);
    // }
  }
  onBrowerChangeHandlerInner(values, datas) {
    this.setState({ searchKeys: values, selectedData: datas });
    const throwDatas = [];
    if (!isEmpty(values)) {
      values.forEach(v => {
        throwDatas.push(datas[v]);
      });
    }
    this.throwCurrentState(values.join(","), this.formatThrowDatas(throwDatas));
  }
  onBrowerChange(values, datas, needOnchange = true) {
    const { destUrl, needCallDest, type } = this.props;
    if (!needCallDest) {
      // 右侧不需要走接口
      let rd = [];
      values.forEach(v => rd.push(datas[v]));
      this.setState({
        searchKeys: values,
        selectedData: datas,
        rightDatas: rd
      });
      if (needOnchange)
        this.throwCurrentState(values.join(","), this.formatThrowDatas(datas));
      return;
    }
    if (!isEmpty(values)) {
      values = uniq(values);
      const method = type == 4 || type == 57 || type == 168 ? "POST" : "GET";
      const params = this.getExtraParams(values.map(v => datas[v]), values);
      WeaTools.callApi(destUrl, method, params).then(
        res => {
          if (!isEmpty(res)) {
            !isEmpty(res.columns) && this.formatInput(res.columns);
            this.setState({
              searchKeys: values,
              selectedData: datas,
              rightDatas: res.datas
            });
            if (needOnchange)
              this.throwCurrentState(
                values.join(","),
                this.formatThrowDatas(res.datas)
              );
          }
        },
        e => {
          console.log("api /api/public/browser/destData error", e);
        }
      );
    } else {
      this.setState({ searchKeys: [], selectedData: {}, rightDatas: [] });
      if (needOnchange) this.throwCurrentState("", []);
    }
  }
  onRightDoubleClick(key) {
    const { rightDatas, inputId } = this.state;
    const newRightDatas = rightDatas.filter(
      item => (item[inputId] || item.id) !== key
    );
    this.onCountChange(newRightDatas);
    this.setState({ rightDatas: newRightDatas, rightCheckedKeys: [] });
  }
  onleftDoubleClick(data) {
    const { rightDatas } = this.state;
    this.onCountChange(rightDatas.concat(data));
    this.setState({
      rightDatas: rightDatas.concat(data),
      rightCheckedKeys: [],
      leftListSelectedData: [],
      leftTreeCheckedData: [],
      leftTreeCheckedKeys: [],
      leftListSelectedKeys: []
    });
  }
  onleftTreeDoubleClick(data) {
    const { rightDatas } = this.state;
    const { destUrl } = this.props;
    WeaTools.callApi(`${destUrl}selectids=${data[0].id}`, "GET").then(res => {
      !isEmpty(res.columns) && this.formatInput(res.columns);
      this.onCountChange(rightDatas.concat(res.datas));
      this.setState({
        rightDatas: rightDatas.concat(res.datas),
        rightCheckedKeys: [],
        leftListSelectedData: [],
        leftTreeCheckedData: [],
        leftTreeCheckedKeys: [],
        leftListSelectedKeys: []
      });
    });
  }
  onCountChange(rightData) {
    const { count } = this.props;
    let result = this.count(rightData) || "";
    this.props.count && this.props.count(result);
  }
  getExtraParams = (data = [], values = []) => {
    const { type } = this.props;
    const {
      checkStrictly,
      leftTreeCheckedKeys,
      leftTreeCheckedData,
      companyId
    } = this.state;
    const params = {};
    const datas = [...leftTreeCheckedData, ...data];
    params.selectids = [...leftTreeCheckedKeys, ...values];
    params.virtualCompanyid = companyId || "1";
    if (type == 4 || type == 57 || type == 168) {
      // 部门、多部门、分权多部门
      let types = datas.map(
        data => `${data.type == "1" ? "subcom" : "dept"}|${data.id}`
      );
      params.types = types;
    }
    if (!checkStrictly) {
      params.alllevel = 1;
    }
    return params;
  };
  moveTo = direction => {
    const { rightDatas, rightCheckedKeys, listDatas, inputId } = this.state;
    const { destUrl } = this.props;
    let rds = [];
    if (direction === "right") {
      const {
        leftListSelectedData,
        leftTreeCheckedData,
        leftTreeCheckedKeys
      } = this.state;
      let datas = leftListSelectedData;
      if (leftTreeCheckedData.length > 0) {
        this.setLoading(true);
        WeaTools.callApi(destUrl, "POST", this.getExtraParams()).then(res => {
          !isEmpty(res.columns) && this.formatInput(res.columns);
          datas = datas.concat(res.datas);
          rds = rightDatas.concat(datas);
          this.onCountChange(rds);
          this.setState({
            rightDatas: rds,
            rightCheckedKeys: [],
            loading: false,
            leftListSelectedData: [],
            leftTreeCheckedData: [],
            leftTreeCheckedKeys: [],
            leftListSelectedKeys: []
          });
        });
      } else {
        rds = rightDatas.concat(datas);
        this.onCountChange(rds);
        this.setState({
          rightDatas: rds,
          rightCheckedKeys: [],
          leftListSelectedData: [],
          leftTreeCheckedData: [],
          leftTreeCheckedKeys: [],
          leftListSelectedKeys: []
        });
      }
    }
    if (direction === "left") {
      rds = rightDatas.filter(
        item =>
          !rightCheckedKeys.some(checkedKey => item[inputId] === checkedKey)
      );
      this.setState({ rightDatas: rds, rightCheckedKeys: [] });
      this.onCountChange(rds);
    }

    if (direction === "allToLeft") {
      this.setState({ rightDatas: [], rightCheckedKeys: [] });
      this.onCountChange(rds);
    }

    if (direction === "allToRight") {
      if (this.leftListAllActive()) {
        rds = rightDatas.concat(listDatas);
        this.setState({
          rightDatas: rds,
          rightCheckedKeys: [],
          leftListSelectedData: [],
          leftTreeCheckedData: [],
          leftTreeCheckedKeys: [],
          leftListSelectedKeys: []
        });
      }
      this.onCountChange(rds);
    }
  };

  moveToLeft = () => this.moveTo("left");
  moveToRight = () => this.moveTo("right");
  moveAllToLeft = () => this.moveTo("allToLeft");
  moveAllToRight = () => this.moveTo("allToRight");

  count(rightDatas = [], rNum = false) {
    const { inputId } = this.state;
    let count = 0;
    let ids = [];
    rightDatas.forEach(item => {
      ids.push(item[inputId]);
    });
    count += uniq(ids).length;
    if (rNum) return count;
    return count > 0 ? `(${count})` : "";
  }
  renderTab() {
    const { tabs } = this.props;
    let TabPanes = [];
    if (!isEmpty(tabs)) {
      tabs.forEach(tab => {
        TabPanes.push(<TabPane tab={tab.name} key={tab.key} />);
      });
      return (
        <Tabs
          onChange={this.onTabsChange.bind(this)}
          activeKey={this.state.activeKey}
        >
          {TabPanes}
        </Tabs>
      );
    }
  }
  leftListAllActive() {
    const { rightDatas, listDatas, inputId } = this.state;
    let bool = true;
    if (isEmpty(listDatas)) bool = false;
    if (!isEmpty(listDatas) && !isEmpty(rightDatas)) {
      bool =
        listDatas.filter(l => !rightDatas.some(r => l[inputId] === r[inputId]))
          .length !== 0;
    }
    return bool;
  }
  resetFields() {
    const { setFieldsValue } = this.props.form;
    const { browserConditions } = this.state;
    const fields = {};
    browserConditions.forEach(c => {
      let ct = c.conditionType.toUpperCase();
      let domkey = c.domkey[0];
      const filterKeys = [1, -1, "1", "-1"];
      if (ct === "BROWSER") {
        if (
          !isEmpty(c.browserConditionParam) &&
          filterKeys.indexOf(c.browserConditionParam.viewAttr) == -1
        ) {
          fields[domkey] = undefined;
          conditionParamsBK[domkey] = "";
        }
      } else if (ct === "SELECT") {
        let v = WeaTools.getSelectDefaultValue(c.options) || "";
        fields[domkey] = v;
        conditionParamsBK[domkey] = v;
      } else if (ct === "DATE") {
        let v = WeaTools.getValueByfield(c);
        if (v && v.value) {
          c.domkey.forEach((d, idx) => {
            fields[d] = v.value[idx];
            conditionParamsBK[d] = v.value[idx];
          });
        }
      } else if (ct === "SCOPE") {
        if (filterKeys.indexOf(c.viewAttr) == -1) {
          fields[domkey] = undefined;
          fields[c.domkey[1]] = undefined;
          conditionParamsBK[domkey] = "";
          conditionParamsBK[c.domkey[1]] = "";
        }
      } else {
        if (filterKeys.indexOf(c.viewAttr) == -1) {
          fields[domkey] = undefined;
          conditionParamsBK[domkey] = "";
        }
      }
    });
    setFieldsValue(fields);
  }
  doChangeEvent = v => {
    const { setFieldsValue } = this.props.form;
    let url = this.getUrl();
    let params = this.getFields();
    params.date2during = v;
    this.getData(url, 1, true, params);
    this.setState({ selectedValue: v });
    setFieldsValue({ date2during: v });
  };
  topComponents = () => {
    const { browserConditions, selectedValue } = this.state;
    const { type } = this.props;
    const tab = this.renderTab();
    const addSelect = () => {
      let options = [];
      let viewAttr = "2";
      browserConditions &&
        browserConditions.forEach(m => {
          if (m.domkey[0] == "date2during") {
            options = m.options;
            if (m.viewAttr) viewAttr = m.viewAttr;
          }
        });
      if (options.length > 0) {
        return (
          <WeaSelect
            viewAttr={viewAttr}
            style={{ width: "100px" }}
            value={selectedValue}
            options={options}
            onChange={this.doChangeEvent}
          />
        );
      }
    };
    if (tab) {
      return (
        <WeaBrowserSearch
          addSelect={type == "152" || type == "171" ? addSelect() : ""}
          tabs={tab}
          searchType={[]}
        />
      );
    }
  };
  reset() {
    this.resetFields();
    this.setState({ inputValue: "" });
  }
  onSelect(item) {
    let company = this.getCompany(this.state.dropmenuDatas, item.key);
    this.setState({
      companyId: item.key,
      companyName: company.name
    });
    let url = this.getUrl();
    this.getData(url, 1, false, {}, null, item.key);
  }
  renderDropmenu() {
    const { dropmenuDatas, companyName } = this.state;
    let menuItem = [];
    dropmenuDatas &&
      dropmenuDatas.map(item => {
        menuItem.push(<Menu.Item key={item.companyid}>{item.name}</Menu.Item>);
        menuItem.push(<Menu.Divider />);
      });
    const typeMenu = (
      <Menu
        className="wea-hr-muti-input-drop-menu wea-browser-drop-menu max-height"
        onSelect={this.onSelect.bind(this)}
      >
        {menuItem}
      </Menu>
    );
    return (
      <Row>
        <Col span={24}>
          <Dropdown overlay={typeMenu} trigger={["click"]}>
            <a className="wea-dropdown-link" href="javascript:;">
              <i className={"icon-toolbar-Organization-list"} />
              <span className="selected-title">{companyName}</span>
              <Icon type="down" style={{ float: "right" }} />
            </a>
          </Dropdown>
        </Col>
      </Row>
    );
  }
  focus() {
    this.refs.associativeSearch.focus();
  }
  render() {
    const {
      hideVirtualOrg,
      bottomLeft,
      buttons,
      icon,
      iconBgcolor = "",
      iconFontColor = "#fff",
      title,
      fieldName,
      contentHeight,
      modalStyle,
      asynLoadAll = false,
      defaultExpandedLevel,
      topPrefix,
      isImgIcon,
      type,
      customized,
      showCheckStrictly,
      checkStrictlyTitle,
      hideAdvanceSearch,
      urlOfIframeInDialog,
      urlOfIframeInDialogKey
    } = this.props;
    const {
      loading,
      visible,
      activeKey,
      showSearchAd,
      listDatas,
      inputValue,
      pageSize,
      count,
      currentPage,
      loadAllTreeData,
      leftTreeCheckedData,
      checkStrictly,
      inputId,
      inputName,
      inputTop,
      inputBottom,
      contentType,
      treeData,
      defaultExpandedKeys,
      hiddenIds,
      dataIcon,
      dataIconBgColor,
      dataIconFontColor
    } = this.state;
    let {
      displayType,
      rightDatas,
      rightCheckedKeys,
      leftTreeCheckedKeys,
      leftListSelectedKeys,
      selectedData,
      searchKeys
    } = this.state;
    searchKeys = uniq(searchKeys || []);
    let titleEle = (
      <Row>
        <Col span="22" style={{ paddingLeft: 20, lineHeight: "48px" }}>
          <div className="wea-hr-muti-input-title">
            {dataIconBgColor || iconBgcolor ? (
              <div
                className="wea-workflow-radio-icon-circle"
                style={{
                  background: dataIconBgColor || iconBgcolor,
                  color: dataIconFontColor || iconFontColor
                }}
              >
                <i className={dataIcon || icon} />
              </div>
            ) : (
              <span style={{ verticalAlign: "middle", marginRight: 10 }}>
                <i className={icon} />
              </span>
            )}
            <span style={{ verticalAlign: "middle" }}>{title}</span>
          </div>
        </Col>
      </Row>
    );
    let inputArr = (
      <WeaAssociativeSearchMult
        {...this.props}
        ref="associativeSearch"
        inputName={inputName}
        inputId={inputId}
        style={this.props.inputStyle}
        datas={selectedData}
        selectedValues={searchKeys}
        type={type}
        clickCallback={this.onBrowerClick}
        onChange={this.onBrowerChangeHandler.bind(this)}
      />
    );
    let footerTemp = [];
    footerTemp.push(
      <Button
        key="submit"
        type="primary"
        onClick={this.handleOk.bind(this)}
        disabled={this.count(rightDatas, true) == 0}
      >
        {getLabel(385565, "确 定")}
        {this.count(rightDatas)}
      </Button>
    );
    if (
      !this.props.browserModalProps ||
      !this.props.browserModalProps.hideClear
    )
      footerTemp.push(
        <Button key="clear" type="ghost" onClick={this.handleClear.bind(this)}>
          {getLabel(385566, "清 除")}
        </Button>
      );
    footerTemp.push(
      <Button key="back" type="ghost" onClick={this.handleCancel.bind(this)}>
        {getLabel(385567, "取 消")}
      </Button>
    );

    const footer = buttons || footerTemp;
    if (bottomLeft)
      footer.unshift(
        <div
          className="ext-link"
          style={{ float: "left", cursor: "pointer", paddingLeft: 20 }}
        >
          {isString(bottomLeft) ? (
            <span dangerouslySetInnerHTML={{ __html: bottomLeft }} />
          ) : (
            <span>{bottomLeft}</span>
          )}
        </div>
      );
    const searchsBox = this.getSearchs();
    const buttonsAd = this.getTabButtonsAd();
    const leftAllActive = displayType === "list" && this.leftListAllActive();
    let initHeight = contentHeight;
    if (window.setLayoutWindow) {
      let maxH = $(window.setLayoutWindow.document.body).height() - 220;
      if (window.setDialogFullWindow || initHeight > maxH) {
        if (isEmpty(this.props.tabs)) {
          maxH += 50;
        }
        initHeight = maxH;
      }
    }
    let sheight = initHeight;
    if (contentType === 1 || contentType === 4) sheight -= 35; //显示分页
    const { dataKey, noPgTableData } = this.state;
    let dom = inputArr;
    if (customized) {
      dom = (
        <div className="cursor-pointer" onClick={this.onCustomClick}>
          {this.props.children}
        </div>
      );
    }
    if (urlOfIframeInDialog) {
      return (
        <div>
          {dom}
          {this.props.extraElement}
          <input
            type="hidden"
            id={fieldName}
            name={fieldName}
            value={hiddenIds}
          />
          <Modal
            wrapClassName="wea-hr-muti-input wea-browser-muli wea-browser-modal wea-browser-iframe-in-dialog"
            title={titleEle}
            zIndex={this.props.zIndex}
            width={modalStyle.width}
            maskClosable={false}
            visible={visible}
            onCancel={this.handleCancel.bind(this)}
            footer={[]}
            {...this.props.browserModalProps}
          >
            <iframe
              key="iframe"
              ref={el => {
                if (
                  el &&
                  this.state.urlOfIframeInDialogParrentHeight === "100%"
                ) {
                  // 由于 modal 多次渲染，目前只能计算一次高度
                  const parrent = $(el).closest(".ant-modal-body");
                  if (parrent.length > 0 && parrent.height() > 0) {
                    const urlOfIframeInDialogParrentHeight = parrent.height();
                    if (urlOfIframeInDialogParrentHeight > 0) {
                      this.setState({ urlOfIframeInDialogParrentHeight });
                    }
                  }
                }
              }}
              style={{
                border: 0,
                width: "100%",
                height: this.state.urlOfIframeInDialogParrentHeight,
                minHeight: 400
              }}
              src={`${urlOfIframeInDialog}${
                /\?/.test(urlOfIframeInDialog) ? "&" : "?"
              }urlOfIframeInDialogKey=${urlOfIframeInDialogKey}`}
            />
          </Modal>
        </div>
      );
    }
    let rightActive = false;
    if (leftListSelectedKeys && leftListSelectedKeys.length > 0) {
      rightActive = true;
    }
    if (leftTreeCheckedKeys && leftTreeCheckedKeys.length > 0) {
      rightActive = true;
    }
    let showDropMenu = type == "194" || type == "57";
    if (hideVirtualOrg) showDropMenu = false;
    if (displayType === "tree") {
      sheight += 35;
      if (showDropMenu) {
        sheight -= 37;
      }
    }
    return (
      <div>
        {dom}
        {this.props.extraElement}
        <input
          type="hidden"
          id={fieldName}
          name={fieldName}
          value={hiddenIds}
        />
        <Modal
          wrapClassName="wea-hr-muti-input wea-browser-muli wea-browser-modal"
          title={titleEle}
          zIndex={this.props.zIndex}
          width={modalStyle.width}
          maskClosable={false}
          visible={visible}
          onCancel={this.handleCancel.bind(this)}
          footer={footer}
          {...this.props.browserModalProps}
        >
          {this.topComponents()}
          <Spin spinning={loading}>
            <div style={{ padding: 10 }}>
              <div
                className={`wea-hr-muti-input-left ${
                  displayType === "tree" ? "displayTree" : ""
                }`}
              >
                {displayType !== "tree" && (
                  <Row style={{ height: "35px" }}>
                    <Col span={hideAdvanceSearch ? "24" : "18"}>
                      <WeaInputSearch
                        placeholder={""}
                        value={inputValue}
                        onSearchChange={v => {
                          this.setState({ inputValue: v });
                        }}
                        onSearch={this.onSearchChange.bind(this)}
                      />
                    </Col>
                    {!hideAdvanceSearch && (
                      <Col span="6">
                        <Button
                          className="wea-workflow-serch-condition"
                          type="ghost"
                          onClick={this.setShowSearchAd.bind(this, true)}
                        >
                          {getLabel(347, "高级搜索")}
                        </Button>
                      </Col>
                    )}
                  </Row>
                )}
                <div
                  className="wea-search-wrap"
                  style={{ display: showSearchAd ? "block" : "none" }}
                >
                  <Button
                    type="ghost"
                    className="wea-advanced-search"
                    onClick={this.setShowSearchAd.bind(this, false)}
                  >
                    {getLabel(347, "高级搜索")}
                  </Button>
                  <div className="wea-advanced-searchs">
                    <Form horizontal>
                      {this.state.initialShowSearchAd && searchsBox}
                      <div className="wea-search-buttons">
                        <div style={{ textAlign: "center" }}>
                          {this.state.initialShowSearchAd &&
                            buttonsAd &&
                            buttonsAd.map(data => {
                              return (
                                <span style={{ marginLeft: 15 }}>{data}</span>
                              );
                            })}
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
                {showDropMenu &&
                  displayType === "tree" &&
                  this.renderDropmenu()}
                <div>
                  <WeaNewScroll height={sheight} ref="weaSrcoll">
                    {displayType === "list" && (
                      <WeaBrowserMutiLeft
                        contentType={contentType}
                        inputId={inputId}
                        inputName={inputName}
                        inputTop={inputTop}
                        inputBottom={inputBottom}
                        onDoubleClick={this.onleftDoubleClick.bind(this)}
                        onClick={this.onLeftListCheck.bind(this)}
                        selectedKeys={leftListSelectedKeys}
                        filterData={rightDatas}
                        datas={listDatas}
                      />
                    )}
                    {displayType === "tree" && (
                      <WeaBrowserTree
                        isImgIcon={isImgIcon}
                        type={type}
                        browserTree={false}
                        onDoubleClick={this.onleftTreeDoubleClick.bind(this)}
                        checkable={true}
                        topPrefix={topPrefix}
                        dataUrl={this.getUrl(false, activeKey)}
                        checkedCb={this.onLeftTreeCheck.bind(this)}
                        // onCheckedKeysChange={this.onLeftTreeCheck.bind(this)}
                        filterData={rightDatas}
                        inputId={inputId}
                        inputName={inputName}
                        checkedDatas={leftTreeCheckedData}
                        // componyParam={componyParam}
                        // setData={this.setData.bind(this)}
                        isMult={true}
                        icon={icon}
                        treeData={treeData}
                        defaultExpandedKeys={defaultExpandedKeys}
                        checkStrictly={checkStrictly}
                        isLoadAll={loadAllTreeData}
                        asynLoadAll={asynLoadAll}
                        defaultExpandedLevel={defaultExpandedLevel}
                      />
                    )}
                  </WeaNewScroll>
                </div>
                {displayType === "tree" && showCheckStrictly && (
                  <Button
                    className={`subordinates-icon ${
                      showDropMenu ? "hasDropMenu" : ""
                    }`}
                    size="small"
                    // title={
                    //   checkStrictlyTitle || getLabel(33454, "包含下级机构")
                    // }
                    title={
                      checkStrictlyTitle ||
                      (checkStrictly
                        ? getLabel(390067, "不包含下级机构")
                        : getLabel(33454, "包含下级机构"))
                    }
                    onClick={() => {
                      this.setState({ checkStrictly: !checkStrictly });
                    }}
                  >
                    <span>
                      {!checkStrictly ? (
                        <i
                          className="icon-coms-DisplaySubordinates"
                          style={{ color: "#2db7f5" }}
                        />
                      ) : (
                        <i className="icon-coms-NoDisplayOfSubordinates" />
                      )}
                    </span>
                  </Button>
                )}
                {(contentType === 1 || contentType === 4) && (
                  <Pagination
                    weaSimple
                    showTotal={total =>
                      getLabel(385617, "共$s条").replace(/\$s/, total)
                    }
                    total={count}
                    pageSize={pageSize}
                    current={currentPage}
                    onChange={this.onPageChange.bind(this)}
                  />
                )}
              </div>
              <div className="wea-transfer-opration">
                <Operation
                  rightActive={rightActive}
                  leftActive={rightCheckedKeys && rightCheckedKeys.length > 0}
                  leftAllActive={leftAllActive}
                  rightAllActive={rightDatas && rightDatas.length > 0}
                  moveToRight={this.moveToRight}
                  moveToLeft={this.moveToLeft}
                  moveAllToRight={this.moveAllToRight}
                  moveAllToLeft={this.moveAllToLeft}
                />
              </div>
              <div className="wea-hr-muti-input-right">
                <WeaBrowserMutiRight
                  ref="browserRight"
                  contentType={contentType}
                  inputId={inputId}
                  inputName={inputName}
                  inputTop={inputTop}
                  inputBottom={inputBottom}
                  data={rightDatas}
                  checkedCb={this.onRightCheck.bind(this)}
                  onDoubleClick={this.onRightDoubleClick.bind(this)}
                  checkedKeys={rightCheckedKeys}
                  height={initHeight}
                  onDrag={data => {
                    this.setState({ rightDatas: data });
                  }}
                />
              </div>
            </div>
          </Spin>
        </Modal>
      </div>
    );
  }
  onLeftListCheck(keys, datas) {
    const { leftListSelectedData, inputId } = this.state;
    let targets = leftListSelectedData.concat(datas);
    targets = uniqBy(targets, inputId || "id");
    targets = targets.filter(t => keys.indexOf(t[inputId || "id"]) > -1);
    this.setState({
      leftListSelectedKeys: keys,
      leftListSelectedData: targets
    });
  }
  onLeftTreeCheck(checkedKeys, datas) {
    this.setState({
      leftTreeCheckedKeys: checkedKeys,
      leftTreeCheckedData: datas
    });
  }
  onRightCheck(keys) {
    this.setState({ rightCheckedKeys: keys });
  }
  throwCurrentState(ids, datas = []) {
    const { inputName, inputId } = this.state;
    ids = uniq(ids.split(",")).join(",");
    this.setState({ hiddenIds: ids });
    let names = [];
    if (!isArray(datas)) {
      datas = toArray(datas);
    }
    datas = uniqBy(datas, inputId || "id");
    datas.forEach(d => {
      if (orgInfoArr.indexOf(this.props.type + "") > -1) {
        d.name =
          d.orgWholePathspan ||
          d[inputName + "span"] ||
          d[inputName] ||
          d.name ||
          "";
        names.push(d.name);
      } else {
        names.push(d[inputName + "span"] || d[inputName] || d.name);
      }
    });
    // names = uniq(names);
    this.props.onChange && this.props.onChange(ids, names.join(","), datas);
  }

  getSearchs() {
    const { browserConditions } = this.state;
    let items = [];
    !isEmpty(browserConditions) &&
      browserConditions.forEach(field => {
        items.push({
          com: (
            <WeaFormItem
              label={`${field.label}`}
              labelCol={{ span: `${field.labelcol}` }}
              wrapperCol={{ span: `${field.fieldcol}` }}
              viewAttr={field.viewAttr}
            >
              {WeaTools.getComponent(
                field.conditionType,
                field.browserConditionParam,
                field.domkey,
                this.props,
                field
              )}
            </WeaFormItem>
          ),
          colSpan: 1,
          hide: WeaTools.isComponentHide(field)
        });
      });
    return <WeaSearchBrowserBox items={items} />;
  }

  getTabButtonsAd() {
    let _this = this;
    const { resetFields, validateFields } = this.props.form;
    return [
      <Button
        type="primary"
        onClick={e => {
          this.goSearch(e);
        }}
      >
        {getLabel(197, "搜索")}
      </Button>,
      <Button
        type="ghost"
        onClick={e => {
          this.reset();
        }}
      >
        {getLabel(2022, "重置")}
      </Button>,
      <Button
        type="ghost"
        onClick={() => {
          _this.setState({ showSearchAd: false });
        }}
      >
        {getLabel(31129, "取消")}
      </Button>
    ];
  }
}

let conditionParamsBK = {};
Main = Form.create({
  onFieldsChange(props, fields) {
    for (let key in fields) {
      conditionParamsBK[fields[key].name] = fields[key].value;
    }
  }
})(Main);
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-muti/index.js